import React, { useEffect, useState } from 'react';
import { Tabs, Tooltip, Row, Col, Breadcrumb } from 'antd';
import { ReactComponent as Check } from 'assets/icons/check.svg';
import { getLocalString, localNames } from 'utils/localisation.service';
import { useSelector, useDispatch } from 'react-redux';
import ApplicationStatusOverview from 'components/applicationStatusOverview';
import { ReactComponent as ViewTaskLink } from '../../assets/icons/view_task_link.gov.svg';
import { useNavigate } from 'react-router-dom';
import { updateFormField } from 'store/forms/actions';
import { isBeneficiary, isCoe } from 'utils';

const { TabPane } = Tabs;

const CustomTabsTimeline = ({
  tabs,
  tabProps,
  customClass,
  current,
  setCurrent,
  activeTask,
  isApptrack,
  ...rest
}) => {
  const dispatch = useDispatch();
  const locales = useSelector(state => state.forms?.localeStrings);
  const [activeTab, setActiveTab] = useState(current);
  const activeTaskId = useSelector(
    state => state.appTrack.apptrackDetails?.activeTaskId
  );
  const apptrackDetails = useSelector(state => state.appTrack.apptrackDetails);

  const user = useSelector(state => state.user);
  const viewModeCoe = useSelector(state => state.forms?.carrier?.viewMode);

  const isViewMode = isCoe(user.groups)
    ? viewModeCoe
    : !window.location.pathname.includes('main-forms');

  const navigate = useNavigate();

  const onViewMode = activeTaskId => {
    // dispatch(claimActiveViewMode(navigate, activeFormId));
    window.open(`/go-beyond/main-forms/${activeTaskId}/view`, '_blank');
  };

  const onChange = key => {
    setActiveTab(Number(key)); // Ensure key is treated as a number
    setCurrent(Number(key)); // Update the parent component
    dispatch(
      updateFormField({
        group: 'carrier',
        key: 'currentSubTab',
        value: 0,
      })
    );
  };

  useEffect(() => {
    setActiveTab(current);
  }, [current]);

  return (
    <div className={`${customClass}`}>
      {isViewMode && (
        <div style={{ paddingTop: '2rem' }}>
          <Breadcrumb separator=">" className="custom-breadcrumb mb-4">
            <Breadcrumb.Item onClick={() => navigate('/appTrack')}>
              Οι Αιτήσεις μου
            </Breadcrumb.Item>
            <Breadcrumb.Item>Δημιουργία Αίτησης</Breadcrumb.Item>
          </Breadcrumb>
        </div>
      )}
      <Tabs
        defaultActiveKey={activeTab.toString()} // Convert to string
        activeKey={activeTab.toString()} // Convert to string
        onChange={onChange}
        {...rest}
      >
        {tabs.map(({ name, label, Component }, index) => (
          <TabPane
            key={index}
            tab={
              <div className="tab-timeline">
                <div className={`ml-1 tab-timeline-index`}>
                  {activeTab > index ? (
                    <Check
                      className={`tab-timeline-check`}
                      width={'14px'}
                      height={'14px'}
                    />
                  ) : (
                    index + 1
                  )}
                </div>
                <div className="tab-timeline-label">
                  {/* {name === "AREAFORM" ? getLocalString(locales, localNames.REQUEST_PAGE_AREA_FORM) :
                    name === "RECEIPT" ? getLocalString(locales, localNames.REQUEST_PAGE_RECEIPT) :
                    name === "OUTPUTLINE" ? getLocalString(locales, localNames.REQUEST_PAGE_OUTPUTLINE) : 
                    name === "DOCUMENTS" ? getLocalString(locales, localNames.REQUEST_PAGE_DOCUMENTS) : 
                    getLocalString(locales, localNames.REQUEST_PAGE_HISTORICITY)} */}
                  {name === 'AREAFORM'
                    ? 'Περιοχή Δραστηριότητας'
                    : name === 'BASICFORM'
                      ? 'Βασικά Στοιχεία Φορέα'
                      : name === 'DOCUMENTS'
                        ? 'Δικαιολογητικά'
                        : name === 'TERMS'
                          ? 'Όροι και Προϋποθέσεις'
                          : name === 'BUSINESSPLAN'
                            ? 'Το Επιχειρηματικό μου Σχέδιο'
                            : name === 'BANK'
                              ? 'Πιστωτικό Ίδρυμα'
                              : name === 'GRAPH'
                                ? 'Συνοπτική Παρουσίαση Κατάστασης'
                                : name === 'INFO'
                                  ? 'Επενδυτικό Σχέδιο'
                                  : getLocalString(
                                      locales,
                                      localNames.REQUEST_PAGE_HISTORICITY
                                    )}
                </div>
                {index === tabs.length - 1 ? '' : <div className="divider" />}
              </div>
            }
          >
            {isApptrack && (
              <Row>
                <Col span={12}>
                  <ApplicationStatusOverview
                    id={apptrackDetails?.businessKey}
                    activeTaskName={apptrackDetails?.activeTaskName}
                  />
                </Col>
                <Col span={12}>
                  {activeTab === 1 && (
                    <div
                      className="tab2-icons"
                      style={{
                        display: 'flex',
                        justifyContent: 'end',
                        marginRight: '2rem',
                        marginTop: '3.25rem',
                      }}
                    >
                      <Tooltip
                        placement="left"
                        title="Δείτε τα αναλυτικά στοιχεία της αίτησης"
                      >
                        <ViewTaskLink
                          style={{ cursor: 'pointer' }}
                          onClick={() => onViewMode(activeTaskId)}
                        />
                      </Tooltip>
                    </div>
                  )}
                </Col>
              </Row>
            )}
            {/* <button>Πίσω στις Αιτήσεις</button> */}
            <Component {...tabProps} />
          </TabPane>
        ))}
      </Tabs>
    </div>
  );
};

export default CustomTabsTimeline;
